import React from 'react';
import { AlertTriangle, XCircle } from 'lucide-react';

interface MembershipWarningModalProps {
  isOpen: boolean;
  message: string;
  type: 'warning' | 'error';  // warning=可继续操作, error=被阻止
  onClose: () => void;
  qrCodeUrl?: string;        // 微信绑定/充值二维码
  alreadyBound?: boolean;    // 是否已绑定微信
}

export const MembershipWarningModal: React.FC<MembershipWarningModalProps> = ({
  isOpen,
  message,
  type,
  onClose,
  qrCodeUrl,
  alreadyBound,
}) => {
  if (!isOpen) return null;

  const isError = type === 'error';

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl max-w-md w-full mx-4 p-6">
        <div className="flex flex-col items-center text-center">
          {isError ? (
            <XCircle className="w-12 h-12 text-red-500 mb-4" />
          ) : (
            <AlertTriangle className="w-12 h-12 text-yellow-500 mb-4" />
          )}

          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            {isError ? '学习币不足' : '续费提醒'}
          </h3>

          <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
            {message}
          </p>

          {qrCodeUrl ? (
            <>
              <img
                src={qrCodeUrl}
                alt="微信小程序二维码"
                className="w-48 h-48 my-3"
              />
              <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">
                {alreadyBound
                  ? '请用微信扫码进入小程序充值'
                  : '请用微信扫码绑定账号并充值'}
              </p>
            </>
          ) : (
            <p className="text-xs text-gray-500 dark:text-gray-400 mb-6">
              请在微信小程序中完成续费
            </p>
          )}

          <button
            onClick={onClose}
            className={`w-full py-2.5 rounded-lg text-white font-medium transition-colors ${
              isError
                ? 'bg-red-600 hover:bg-red-700'
                : 'bg-yellow-500 hover:bg-yellow-600'
            }`}
          >
            我知道了
          </button>
        </div>
      </div>
    </div>
  );
};
